export const mobileRegex = /^([6-9]{1})([0-9]{9})$/;

export const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;